import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HoldingTypeAutocompleteComponent } from './holding-type-autocomplete.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PreloaderModule } from '@shared/component/preloader/preloader.module';
import { ValidationErrorModule } from '@shared/component/validation-error/validation-error.module';
import { DirectivesModule } from '@shared/directives/directives.module';
import { MaterialModule } from '@shared/material/material.module';

@NgModule({
  declarations: [
    HoldingTypeAutocompleteComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    DirectivesModule,
    ValidationErrorModule,
    PreloaderModule
  ],
  exports: [
    HoldingTypeAutocompleteComponent
  ]
})
export class HoldingTypeAutocompleteModule { }
